/**
 * Id list of all possible predefined sound effects
 */
export enum SoundEffectId {
    MoteUnlocked = "MoteUnlocked",
    QuizCountdown = "QuizCountdown",
    QuizShowQuestion = "QuizShowQuestion",
    QuizAnswerSelected = "QuizAnswerSelected",
    QuizCorrectAnswer = "QuizCorrectAnswer",
    QuizWrongAnswer = "QuizWrongAnswer",
};

/**
 * The current state of the sound effect defining if it is loaded in dom and ready to play etc. 
 */
export enum SoundEffectState {
    DISABLE = "DISABLE",
    LOAD = "LOAD",
    READY = "READY",
    PREPARED = "PREPARED"
}

/**
 * Sound effect interface represents a sound, with a predefined id, url and
 * a dynamically loaded audio element and state that links the sound to the dom
 */
export interface SoundEffect {
    id: SoundEffectId,
    url: string,
    state: SoundEffectState,
    player?: HTMLAudioElement
}

/**
 * Define map of sound effects type
 */
export type SoundEffectMap = { [id in keyof typeof SoundEffectId]: SoundEffect };


/**
 * Define urls of all possible sound effects
 */
export const SoundEffectList: SoundEffectMap = {
    MoteUnlocked: { id: SoundEffectId.MoteUnlocked, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Funlock_theme_short.mp3?alt=media&token=4930ed35-7553-4fac-a91f-d03918e694fe' },
    QuizCountdown: { id: SoundEffectId.QuizCountdown, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Fquiz-countdown.mp3?alt=media&token=8da4dafd-e4df-4b84-b002-5c4aa0621354' },
    QuizCorrectAnswer: { id: SoundEffectId.QuizCorrectAnswer, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Fcorrect_answer.mp3?alt=media&token=59807f42-c6c9-4d26-8af3-637760bab1a8' },
    QuizAnswerSelected: { id: SoundEffectId.QuizAnswerSelected, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Fselect_answer.mp3?alt=media&token=4382c119-901c-4e5d-877b-4fb3dbfef5e4' },
    QuizWrongAnswer: { id: SoundEffectId.QuizWrongAnswer, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Fwrong_answer.mp3?alt=media&token=569b6e5f-8c9e-4e48-a5fe-cec1eb29fcb2' },
    QuizShowQuestion: { id: SoundEffectId.QuizShowQuestion, state: SoundEffectState.DISABLE, url: 'https://firebasestorage.googleapis.com/v0/b/motesdev.appspot.com/o/static-sounds%2Fquiz-ambience.mp3?alt=media&token=96d403e3-1126-49d4-982c-c60297b67e5f' },
};
